<template>
        <div class="animated fadeIn">
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong v-if="wto.status">{{title}} - {{wto.status}}</strong>
                            <strong v-else>{{title}}</strong>
                        </div>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group>
                                    <label for="wto_date" >WTO Date</label>
                                        <b-form-input type="date" v-model="wto.wto_date" :disabled="lockEntry"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <label for="location_id">Country</label>
                                    <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="wto.country_id" :disabled="lockEntry"/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <label for="location_id">Location From (Warehouse)</label>
                                    <warehouseLookup ref="warehouseFrom" v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouseFrom($event)" :lookupId="wto.from_location_id" :q2="wto.country_id" :disabled="wto.country_id =='' || lockEntry" />
                            </b-col>
                            <b-col sm="6">
                                <label for="location_id">Location To (Warehouse)</label>
                                    <warehouseLookup ref="warehouseTo" v-bind:url="apiWarehouseUrl" @selected="setWarehouseTo($event)" :lookupId="wto.to_location_id" :q2="wto.country_id" :disabled="wto.country_id == '' || lockEntry" />
                            </b-col>
                        </b-row>
                        <br/>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group>
                                    <label for="reason" >Reason</label>
                                        <b-form-input type="text" v-model="wto.reason" :disabled="lockEntry" maxlength="255"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                    <b-form-group>
                                        <label for="reference_num" >Reference Num</label>
                                            <b-form-input type="text" v-model="wto.reference_num" :disabled="lockEntry" maxlength="255"></b-form-input>
                                    </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <label for="remarks">Remarks</label>
                                    <textarea class="form-control" rows="5" id="remarks" v-model="wto.remarks" :disabled="lockEntry"></textarea>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="checkValue()">
                    <b-card>
                        <div slot ="header">
                            <strong>WTO Items</strong>
                        </div>
                        <div class="table-responsive">
                        <table class='table table-striped table-bordered'>
                                <thead>
                                    <th width="10px">S/N</th>
                                    <th style="min-width:300px">Product Name</th>
                                    <th width="250px">Product Code</th>
                                    <th width="150px">SOH</th>
                                    <th width="180px">Transfer Qty</th>
                                    <th width="30px"></th>
                                </thead>
                                <tbody>
                                    <tr v-for="row,index in wto.wto_items">
                                        <td>{{(index*1)+1}}</td>
                                        <td>
                                            <productLookup v-bind:url="apiLocationProductUrl" v-on:selected="setProduct($event,index)" :lookupId="row.product_id" :q2="wto.from_location_id" :get="0" :disabled="lockEntry"/>
                                        </td>
                                        <td >{{row.product_id}}</td>
                                        <td v-if="!lockEntry">{{row.qty_soh*1 - row.qty*1}}</td>
                                        <td v-if="lockEntry">{{row.qty_soh*1}}</td>
                                        <td><input type="number" name="qty" v-model="row.qty" class="form-control" @change="validateQty(index)" :disabled="lockEntry"/></td>
                                        <td><a href="#" @click="removeRow(index)" v-if="!lockEntry" tabindex="-1"><i class='fa fa-trash' style="font-size:25px;color:red;"></i></a></td>
                                    </tr>
                                        <tr>
                                            <td colspan=7>
                                                <b-button type="submit" size="md" variant="success" @click="addRow" v-if="!lockEntry">Add Product</b-button>
                                            </td>
                                        </tr>
                                </tbody>
                        </table>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="checkValue()">
                    <b-row style="padding: 0px 0px 20px 18px;">
                            <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="!lockEntry">Save WTO</b-button>
                                 &nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="danger" @click="confirmCancel" v-if="!lockEntry">Cancel</b-button>
                            <b-button type="submit" size="lg" variant="primary" @click="confirmManualClose" v-if="lockEntry && !hideBtns">Manual-Close</b-button>
                            &nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="success" @click="print" v-if="lockEntry">Print</b-button>
                            &nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="danger" @click="back" v-if="lockEntry">Back</b-button>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-modal v-model="modalShow" @ok="save" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                    <p style="color:darkblue">Confirmed Save WTO?</p>
                </b-modal>
                <b-modal v-model="modalManualCloseShow" @ok="manualClose" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                    <p style="color:darkblue">Confirmed Manual Close?</p>
                </b-modal>
                <b-modal v-model="modalCancelShow" @ok="cancel" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                    <p style="color:darkblue">Confirmed Cancel WTO?</p>
                </b-modal>
                <b-modal ref="myModalRef" hide-header-close hide-footer title="Warehouse Transfer Order" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p>Warehouse Transfer Order <strong style="color:green"> {{wtoDocNo}}</strong> is {{displayTxt}}.<br/><br/></p>
                    </div>
                    <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
                </b-modal>
                <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p style="color:red">{{errorMessage}}</p>
                    </div>
                    <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
                </b-modal>
            </b-row>
        </div>
    </template>
    <script>
    import axios from 'axios'
    import warehouseLookup from '@/components/Autocomplete.vue'
    import countryLookup from '@/components/Autocomplete.vue'
    import productLookup from '@/components/Autocomplete.vue'
    import {authHeader, apiWarehouseLookup, apiLocationProductUrl, apiCountryLookup, apiWtoSave, apiWtoGet, apiWtoManualClose} from '@/functions/common.vue'

    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        "ukai": {
            normal: 'ukai.ttf',
            bold: 'ukai.ttf',
            italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
        },
    };

    export default
    {
        components:{warehouseLookup,productLookup,countryLookup},
        data: () => {
            return {
                parentName: 'Warehouse Transfer Orders',
                defaultTitle: 'Warehouse Transfer Order',
                title:'New WTO',
                country_name:'',
                apiWarehouseUrl:apiWarehouseLookup,
                apiCountryLookup:apiCountryLookup,
                apiLocationProductUrl:apiLocationProductUrl,
                docRef: '',
                hideBtns: false,
                modalManualCloseShow:false,
                displayTxt:'',
                prevWhId:'',
                preCountryId:'',
                lockEntry:false,
                wto_status:'',
                modalShow:false,
                modalCancelShow:false,
                wtoDocNo:'',
                errorMessage:'',
                wto :
                {
                    wto_date:'',
                    country_id:'',
                    from_location_id:'',
                    to_location_id:'',
                    reference_num:'',
                    reason:'',
                    remarks:'',
                    wto_items :
                    [
                      {product_name:'', product_id:'', qty_soh:'', qty:''}
                    ]
                }
            }
        },
        created()
        {
            //console.log(this.wto.status)
            this.docRef = this.$route.params.wtoNum
            if(this.docRef == '_new')
            {
                let curDate = new Date()
                curDate = curDate.toISOString().substr(0,10)
                this.wto.wto_date = curDate
            }
            else
            {
                this.fetch(this.docRef)
                this.lockEntry = true
            }
        },
        methods:
        {
            validateQty (index)
            {
                var items = this.wto.wto_items
                if(items[index].qty < 0)
                {
                    items[index].qty = 0
                }
            },
            print()
            {
                    var wto_num = this.wto.wto_num
                    var row = []
                    var date = new Date(this.wto.wto_date)
                    var wtoDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var wtoItems = []
                    var groTotalAmount = 0
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'SOH',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                        {
                            text: 'Transfer Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                    ]
                    wtoItems.push(row)
                    var items = this.wto.wto_items
                    for (let key in items) {
                        var data = items[key]
                        var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null)
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: soh,
                                style: 'itemNumber'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                        ]
                        wtoItems.push(row)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN ' + this.country_name +' WAREHOUSE TRANSFER ORDER',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'WTO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: wto_num,
                                                    style: 'invoiceSubValue',
                                                    width: 150
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'WTO Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: wtoDate,
                                                    style: 'invoiceSubValue',
                                                    width: 150

                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.status,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns:
                                            [
                                                {
                                                    text: 'Country',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.country_id,
                                                    style: 'invoiceSubValue',
                                                }

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Stock Location From',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.from_location_full,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns:
                                            [{
                                                    text: 'Stock Location To',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.to_location_full,
                                                    style: 'invoiceSubValue',

                                                },
                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reason',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.reason,
                                                    style: 'invoiceSubValue',

                                                },
                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reference #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wto.reference_num,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: wto_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 45, 45],
                                    body: wtoItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: this.wto.remarks,
                                style: 'notesText'
                            },
                            {
                                columns: [
                                        {
                                            stack: [
                                                {
                                                    text: 'Issued By',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: 'Name  : '+this.wto.author_user_shortname,
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: 'Date  : ' + wtoDate,
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 160
                                        },
                                        {
                                            stack: [
                                                {
                                                    text: '  ',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '                      ',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: '  ',
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: '      ',
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 180
                                        },
                                        {
                                            stack: [
                                                {
                                                    text: 'Received By',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: 'Name  :',
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        },
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:'ukai'
                        }
                    }
                    pdfMake.createPdf(dd).open();
                },
            save()
            {
                axios.post(apiWtoSave, this.wto, authHeader())
                            .then (res => {
                            var r = res.data
                            if (r.code == 1)
                            {
                                this.wtoDocNo = r.data.wto_num
                                this.displayTxt = " saved"
                                this.$refs.myModalRef.show()
                            }
                            else
                            {
                                this.errorMessage = r.msg
                                this.$refs.myErrorModalRef.show()
                            }
                            })
                .catch(error => console.log(error))
            },
            fetch(docNum)
            {
                axios.post(apiWtoGet, {wto_num:docNum},authHeader())
                .then (res =>
                {
                  var data
                  data = res.data.data
                  this.wto_status = data.status
                  if(this.wto_status == 'MANUAL-CLOSED' || this.wto_status == 'CLOSE')
                    {
                        this.hideBtns = true
                    }
                  this.wto = data

                  if(this.wto.country_id != null)
                            {
                                axios.get(apiCountryLookup, {params: {q: this.wto.country_id}})
                                    .then(response =>
                                    {

                                        if (response.data != null)
                                        {
                                            this.list = response.data.data.list
                                            this.item = this.list[0]
                                            this.country_name = this.item.country_name
                                            this.country_name = this.country_name.toUpperCase()
                                        }
                                    })
                            }
                  this.title = this.defaultTitle + ' ' + docNum
                })
                .catch(error => alert(error)
              )
            },
            setWarehouseFrom(obj)
            {
              if (!this.lockEntry)
              {
                var id = obj.id
                var id2 = this.wto.to_location_id
                // Determine if check is required
                this.prevCountryId = this.wto.country_id
                if (id2 != null)
                {
                        // Yes, check is required
                        if (id == id2)
                        {
                            id = null
                            this.$refs.warehouseFrom.clear()
                        }
                }

                this.wto.from_location_id = id
                this.wto.wto_items = []
              }
            },
            setWarehouseTo(obj)
            {
                if(!this.lockEntry)
                {
                    var id = obj.id
                    var id2 = this.wto.from_location_id
                    this.prevCountryId = this.wto.country_id
                    // Determine if check is required
                    if (id2 != null)
                    {
                            // Yes, check is required
                            if (id == id2)
                            {
                                id = null
                                this.$refs.warehouseTo.clear()
                            }

                    }

                    this.wto.to_location_id = id
                    this.wto.wto_items = []
                }
            },
            checkValue ()
            {
                var show = false
                if (this.wto.from_location_id !='' && this.wto.to_location_id != '')
                {
                    if (this.wto.from_location_id !=null && this.wto.to_location_id !=null)
                    {
                        show = true
                    }
                    else
                    {
                        show = false
                    }
                }
                else
                {
                    show = false
                }
                return show
            },
            setProduct(obj, index)
            {
            if (!this.lockEntry)
            {
                this.prevWhId = this.wto.from_location_id

                if (obj != [])
                {
                    var name, id, qty_soh, unit_gmp

                    var isDuplicatedEntry = false
                    var items = this.wto.wto_items

                    for(let n = 0; n < items.length; n++)
                    {
                        if (n != index)
                        {
                            if (items[n].product_id == items[index].product_id  && items[index].product_id != "")
                            {
                                isDuplicatedEntry = true
                            }

                            if (isDuplicatedEntry)
                                break;
                        }
                    }
                    if (!isDuplicatedEntry)
                    {
                        if(obj !== null)
                        {
                            if (obj.id == "")
                            {
                                qty_soh = ""
                                unit_gmp = ""
                            }
                            else
                            {
                                name = obj.name
                                id = obj.id
                                qty_soh = obj.qty_soh
                                unit_gmp = obj.unit_gmp
                            }
                        }
                        else
                        {
                            name = ""
                            id = ""
                            qty_soh = ""
                            unit_gmp=""

                        }

                        if (isNaN(qty_soh))
                        qty_soh = ""
                    }
                    else
                    {
                        name = ""
                        id = ""
                        qty_soh = ""
                        unit_gmp=""
                    }

                    this.wto.wto_items[index].product_id = id
                    this.wto.wto_items[index].product_name = name
                    this.wto.wto_items[index].qty_soh = qty_soh
                    this.wto.wto_items[index].qty = 0
                }
            }
        },
        addRow ()
        {
            this.wto.wto_items.push({product_id:'', product_name:'', qty_soh:'', qty:''});
        },
            removeRow (index)
            {
                this.wto.wto_items.splice(index, 1);
            },
            setCountry(obj)
            {
               if(!this.lockEntry)
               {
                    var id
                    if (obj !== null)
                    {
                    id = obj.id
                    }
                    else
                    {
                    id = null
                    }
                    this.wto.country_id = id

                    if(this.wto.country_id == '' || this.wto.country != this.prevCountryId)
                    {
                        this.wto.wto_items =[]
                        this.wto.from_location_id =null
                        this.wto.to_location_id = null
                    }
               }
            },
            confirmManualClose()
            {
                this.modalManualCloseShow = true
            },
            confirmSave()
            {
                this.modalShow = true
            },
            confirmCancel()
            {
                this.modalCancelShow = true
            },
            cancel()
            {
                this.$router.push({ name:'Warehouse Transfer Orders (WTOS)'})
            },
            hideModal ()
            {
                this.$refs.myModalRef.hide()
                this.$router.push({  name:'Warehouse Transfer Orders (WTOS)' })
            },
            hideErrorModal()
            {
                this.$refs.myErrorModalRef.hide()
            },
            back()
            {
                this.$router.push({ name: 'Warehouse Transfer Orders (WTOS)'})
            },
            manualClose()
            {
                this.hideBtns = true
                axios.post(apiWtoManualClose, {wto_num: this.wto.wto_num, approve: 1},authHeader())
                    .then (res => {
                        var r = res.data
                        if (r.code == 1)
                            {
                                this.wtoDocNo = r.data.wto_num
                                this.displayTxt = "manual-closed"
                                this.hideBtns = true
                                this.$refs.myModalRef.show()
                            }
                            else
                            {
                                this.errorMessage = r.msg
                                this.$refs.myErrorModalRef.show()
                            }
                    })
                    .catch(error => alert(error))
            }
        }
    }
    </script>
   <style>
    .main {overflow-x: overlay;overflow-y: overlay;}
   </style>



// WEBPACK FOOTER //
// src/views/wto/wto.vue